import $ from 'jquery'
import { $elementExists } from './shared'

const scroll_config = {
    type: 'smooth',
}

export const initScrollUpButton = () => {
    const $button = $('#scrollUpButton')

    if (!$elementExists($button)) return

    $button.on('click', () => {
        $('html, body').animate({ scrollTop: 0 }, scroll_config.type)
    })
}
